// extracted by mini-css-extract-plugin
export default {"emptyLayers":"xu18q","icon":"bH8fu","title":"ty53G","text":"wPHoD"};